'use strict';
import merge from 'deepmerge';


const configs = import.meta.glob('./*.js', {eager: true});
const mode = (process.env.NODE_ENV || 'development').toLowerCase();

// generic/default configurations go here. They will be overwritten by
// production/development settings.
const config = {
    appTitle: 'Auto Refi Form',
    defaultVehicleInfoType: 'vin', // This can be `vin` or `license`
    disableLicenseLookup: true,
    mixpanelKeys: {
        production: '969082b11d312e29b5a7b4549d892af3',
        qa: '212f7fadd03ab0287195ca1372ca2fa0',
        test: '212f7fadd03ab0287195ca1372ca2fa0',
        development: '6be4b1f68669f17f904e48ee9d24a74e'
    },
    fbId: '1532159510136554',
    fbAppId: '1167926103336295',
    mode
};

const envConfig = configs[`./${mode}.js`]?.default || configs[`./${mode}.js`] || {};

export default merge(config, envConfig);
